import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { GraphQLResponse } from '../../../types';
import { CourseStatus, CourseView } from '../../../types/course';
import { COURSES_LIST } from '../../query/courses';

export default function useCourses() {
  const { data: dataCourses } = useQuery<GraphQLResponse<'courses', CourseView[]>>(COURSES_LIST, {
    variables: {
      count: 50,
    },
  });

  const courses = dataCourses?.courses?.data;

  const courseOptions = useMemo(
    () =>
      courses
        ?.filter(c => c.status === CourseStatus.PUBLISHED)
        .map(c => ({
          value: c.id.toString(),
          label: c.name,
          data: c,
        })),
    [courses]
  );

  return { courses, courseOptions };
}
